import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import ConditionalLink from "@wrappers/ConditionalLink/ConditionalLink"
import Button from "@components/Button/Button"
import InputField from "@components/nonDLSComponents/InputField/InputField.js"
import { directAxiosInstance } from "@lib/api"
import { getAssetPath, Validate } from "@commonUtils"
import { useDispatch, useSelector } from "react-redux"
import { excludeCorporateRedirection } from "@commonUtils"
import { setDefault } from "../reducer"
import css from "../Auth.scss"
import { setDefaultAuthConfig } from "@containers/App/reducer"
import ARIAButton from "@wrappers/ARIAButton/ARIAButton"
const TokenMerge = ({ backHandler, onSuccess, forwardHandler, state, localDispatch }) => {
    const { authConfig } = useSelector((state) => state.shellReducer)
    const { info } = state
    const [timeLeft, setTimeLeft] = useState(30)
    const [error, setError] = useState(null)
    const [active, setActive] = useState(false)
    const dispatch = useDispatch()
    // we are using "active" as a flag so that untill the request is completed, we do not allow multiple request
    // on multiple clicks on cta
    const [ctaLabel, setCtaLabel] = useState("Done")
    const [otp, setOtp] = useState("")
    const [alertType, setAlertType] = useState("error")
    const [iconUrl, setIconUrl] = useState(null)
    useEffect(() => {
        if (timeLeft > 0) {
            setTimeout(() => setTimeLeft(timeLeft - 1), 1000)
        }
    }, [timeLeft])
    const [focused, setFocused] = useState(false)
    const onFocus = () => {
        setFocused(true)
    }

    const onBlur = () => {
        if (otp === "") {
            setFocused(false)
        }
    }
    /**
     * @description when user come on this screen cursor should be on inputField .
     */
    const inputRef = useRef(null)
    useEffect(() => {
        setFocused(true)
        inputRef.current.focus()
    }, [])
    /**
     *
     * @description Function to submit the form by clicking on enter
     */
    const onKeyUp = (event) => {
        if (event.key === "Enter") {
            verifyTokenMerge()
        }
    }
    /**
     * @description Function to check valid input
     */

    const errorCheck = () => {
        setError(null)
        const errs = Validate({
            otp: otp,
        })
        setError(errs)
        if (errs) {
            setAlertType("error")
        }
        return errs
    }

    /**
     * @description Function to resend otp for merge flow
     */

    const resendOtpPhone = (onCall = false) => {
        directAxiosInstance()
            .post("auth/email/create_token_merge", {
                number: info.phone,
                email: info.email,
                otp_on_call: onCall,
            })
            .then((res) => {
                if (res && res.data) {
                    setTimeLeft(30)
                    setError({
                        otp: ` You will receive ${onCall ? "a" : "an"} ${onCall ? "call" : "sms"} with OTP`,
                    })
                    setAlertType("success")
                    setTimeout(() => {
                        setError({
                            otp: null,
                        })
                    }, 30000)
                }
            })
            .catch((err) => {
                const errMsg = err?.data?.error?.message || "Server error"
                setError({ otp: errMsg })
                setAlertType("error")
            })
    }

    /**
     * @description Function for merge flow
     */

    const verifyTokenMerge = () => {
        const errs = errorCheck()

        if (!errs && !active) {
            setActive(true)
            setIconUrl(getAssetPath("svgs/icons/loading-wheel_24px_background.svg"))
            directAxiosInstance()
                .post("auth/email/verify_token_merge", {
                    email: info.email,
                    number: info.phone,
                    verification_token: otp,
                })
                .then((res) => {
                    if (res && res.data) {
                        const userData = res?.data?.user_data
                        if (userData) {
                            const corporateRedirectionUrl = excludeCorporateRedirection()
                            onSuccess(userData, corporateRedirectionUrl)
                        }
                    }
                    setIconUrl(null)
                    setCtaLabel("Done")
                    setActive(false)
                })
                .catch((err) => {
                    setIconUrl(null)
                    setCtaLabel("Continue")
                    setTimeLeft(0)
                    const errMsg = err?.data?.error?.message || "Server error"
                    setError({ otp: errMsg })
                    setAlertType("error")
                    setActive(false)
                })
        }
    }

    return (
        <>
            <div className={css.rightContainer}>
                {!authConfig.restrictUserFromClosingAuth && (
                    <div className={`flex ${css.crossIcon} ${css.cursorPointer}`}>
                        <div>
                            <ARIAButton
                                onClick={() => {
                                    dispatch(setDefaultAuthConfig())
                                    localDispatch(setDefault())
                                }}
                                ariaLabel={"Close token merge popup"}
                            >
                                <img
                                    src={getAssetPath("svgs/icons/cross_18px_primary.svg")}
                                    alt={"Close icon"}
                                />
                            </ARIAButton>
                        </div>
                    </div>
                )}
                <div className={`${css.authContainer}`}>
                    <div className={`${css.otpContainer} flex flexColumn justifyBetween`}>
                        <div>
                            <span className={css.heading}>Verify Otp</span>
                            <div className={`smallRegular ${css.subHeadingMargin}`}>
                                Provide OTP sent to <span>{info.phone}</span>
                                <span
                                    className={`textAction smallSemiBold ${css.marginLeft4}`}
                                    onClick={() => backHandler()}
                                >
                                    <u>Edit</u>
                                </span>
                            </div>
                            <div>
                                <span className={css.marginBottom16} data-testid="inputField_tokenMerge">
                                    <InputField
                                        label={"One Time Password"}
                                        onChange={setOtp}
                                        alertMessage={error && error.otp}
                                        countDown={timeLeft ? `Resend in 00:${timeLeft}` : ""}
                                        focused={focused}
                                        onFocus={() => onFocus()}
                                        onBlur={() => onBlur()}
                                        borderType={"primary"}
                                        onKeyUp={(e) => onKeyUp(e)}
                                        alertType={alertType}
                                        ref={inputRef}
                                    />
                                </span>

                                {info.phone && (
                                    <div className="flex justifyAround">
                                        {!timeLeft && (
                                            <>
                                                <ConditionalLink
                                                    className={`textAction bodySemiBold ${css.cursorPointer}`}
                                                    onClick={() => resendOtpPhone()}
                                                >
                                                    Get OTP on SMS
                                                </ConditionalLink>
                                                <div className={`${css.marginBoth12} textSecondary`}>|</div>
                                                <ConditionalLink
                                                    className={`textAction bodySemiBold ${css.cursorPointer}`}
                                                    onClick={() => resendOtpPhone(true)}
                                                >
                                                    Get OTP on Call
                                                </ConditionalLink>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className=" flex flexColumn justifyBetween  ">
                            <Button
                                label={!iconUrl ? ctaLabel : null}
                                iconUrl={iconUrl}
                                isDisabled={iconUrl ? true : false}
                                onClick={() => verifyTokenMerge()}
                            />
                            <div className="marginTop-64 flexColumn alignCenter">
                                <div className={css.footerSubText}>
                                    <span>
                                        <ConditionalLink
                                            className={`textAction xSmallSemiBold  ${css.cursorPointer}`}
                                            onClick={() => forwardHandler("NeedHelp")}
                                        >
                                            <span>Need Help?</span>
                                            <span className={css.marginLeft4}> Get in touch</span>
                                        </ConditionalLink>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

TokenMerge.propTypes = {
    backHandler: PropTypes.func,
    forwardHandler: PropTypes.func,
    onSuccess: PropTypes.func,
    state: PropTypes.shape({
        info: PropTypes.shape({
            email: PropTypes.string,
            phone: PropTypes.string,
        }),
    }).isRequired,
    localDispatch: PropTypes.func.isRequired,
}

export default TokenMerge
